module.exports = __webpack_public_path__ + "img/bg06.2b6a052a.png";